/* HH cart-add analytics.

   WHY THIS EXISTS
   ---------------
   The Grip-X buy box adds to cart with a native fetch taken from a hidden iframe
   (see the comment at the top of hh-sub-tiers.js): Appstle and Fly both patch
   window.fetch on the PDP and silently strip selling_plan from /cart/add.js, so
   the iframe is the only way to keep the subscription on the line.

   The side effect is that Shopify's own analytics ALSO hooks window.fetch. Its
   events carry "add_to_cart_api_source":"add-fetch" and
   "source":"trekkie-storefront-renderer", which is literally trekkie watching
   that patched fetch. An add issued from the iframe is invisible to it, so
   product_added_to_cart never fired and sessions_with_cart_additions collapsed
   on 7 Sep 2026. Purchases still reported because those are recorded server side.

   So: after a successful add, we announce it ourselves.

   TWO SINKS, AND THEY ARE NOT INTERCHANGEABLE (measured on the live store,
   24 Sep 2026 - this is the part that is easy to get wrong):

     1. ShopifyAnalytics.lib.track('Added Product', ...)
        DOES produce a monorail product_added_to_cart event. This is the one
        that feeds Shopify's own sessions_with_cart_additions.

     2. Shopify.analytics.publish('product_added_to_cart', ...)
        Feeds the Web Pixels bus - custom pixels, and app pixels such as Meta
        and TikTok. Verified: on its own it emits NO monorail event, so it does
        NOT move Shopify's metric. It returns without error, which is why it
        looks like it worked.

   Both are called, because they serve different consumers. Dropping (1) would
   leave the reporting bug exactly where it was.

   Everything here is wrapped so that a failure can never interrupt an add. */
(function () {
  'use strict';
  if (window.HHCartTrack) return;

  function cents(v) { return Math.round(Number(v) || 0) / 100; }

  function currency() {
    try {
      var c = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.currency;
      return c || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
    } catch (e) { return 'AUD'; }
  }

  /* Unit price. final_price is the per-unit price after line-level discounts;
     the tier discounts on this store are cart-level automatic discounts, so
     final_price normally equals price - which matches what Shopify's own native
     event sends for a Dawn add. */
  function unitPrice(it) {
    return cents(it.final_price != null ? it.final_price : it.price);
  }

  /* (1) Shopify's first-party funnel metric. */
  function trackTrekkie(it) {
    var lib = window.ShopifyAnalytics && window.ShopifyAnalytics.lib;
    if (!lib || typeof lib.track !== 'function') return false;
    lib.track('Added Product', {
      variantId: it.variant_id,
      productId: it.product_id,
      name: it.title || it.product_title,
      price: String(unitPrice(it)),
      sku: it.sku || '',
      brand: it.vendor || '',
      variant: it.variant_title || '',
      category: it.product_type || '',
      quantity: it.quantity,
      currency: currency(),
      nonInteraction: true
    });
    return true;
  }

  /* (2) Web Pixels bus. Shape per shopify.dev product_added_to_cart - note that
     every amount is a NUMBER, not a string. */
  function publishPixel(it) {
    var a = window.Shopify && window.Shopify.analytics;
    if (!a || typeof a.publish !== 'function') return false;
    var cur = currency();
    var unit = unitPrice(it);
    var lineTotal = it.final_line_price != null ? cents(it.final_line_price) : unit * it.quantity;
    a.publish('product_added_to_cart', {
      cartLine: {
        cost: { totalAmount: { amount: lineTotal, currencyCode: cur } },
        merchandise: {
          id: String(it.variant_id),
          price: { amount: unit, currencyCode: cur },
          product: {
            id: String(it.product_id),
            title: it.product_title,
            vendor: it.vendor || '',
            type: it.product_type || '',
            untranslatedTitle: it.untranslated_product_title || it.product_title,
            url: it.url ? (window.location.origin + String(it.url).split('?')[0]) : null
          },
          sku: it.sku || null,
          title: it.variant_title || null,
          untranslatedTitle: it.untranslated_variant_title || it.variant_title || null
        },
        quantity: it.quantity
      }
    });
    return true;
  }

  /* ONE event per line item, once, only after the add has already succeeded.
     Takes the /cart/add.js response, whose `items` array is the authoritative
     list of what was just added - real variant ids, real quantities, real
     prices. A bundle that adds Grip-X plus a Bonus Pack arrives here as two
     entries and produces two events, which is what the schema expects. */
  function track(res) {
    try {
      var items = res && res.items ? res.items : (Array.isArray(res) ? res : null);
      if (!items || !items.length) return 0;
      var n = 0;
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (!it || !it.variant_id || !(it.quantity > 0)) continue;
        try { trackTrekkie(it); } catch (e) { /* never break the add */ }
        try { publishPixel(it); } catch (e) { /* never break the add */ }
        n++;
      }
      return n;
    } catch (e) { return 0; }
  }

  window.HHCartTrack = track;

  /* ------------------------------------------------------------------
     The cart drawer's cross-sell button.

     snippets/cart-drawer.liquid adds through its own iframe fetch, and at 47KB
     that file cannot be rewritten safely through this channel, so we cannot
     hand it the response the way the buy box does. Instead: snapshot the cart
     when the button is clicked, look again once it has landed, and report the
     difference.

     This is armed ONLY by a click on [data-hh-xsell], so it cannot double-count
     a buy-box add, and it stays silent if the add fails (no delta, no event).
     ------------------------------------------------------------------ */
  function qtyByVariant(cart) {
    var m = {};
    ((cart && cart.items) || []).forEach(function (l) {
      m[l.variant_id] = (m[l.variant_id] || 0) + l.quantity;
    });
    return m;
  }
  function readCart() {
    try {
      return window.fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })['catch'](function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-hh-xsell]') : null;
    if (!btn) return;
    var wrap = btn.closest('.hh-xsell');
    var sel = wrap ? wrap.querySelector('.hh-xsell-size') : null;
    var vid = sel ? parseInt(sel.value, 10) : 0;
    if (!vid) return;

    readCart().then(function (before) {
      if (!before) return;
      var was = qtyByVariant(before), tries = 0, done = false;
      (function look() {
        tries++;
        setTimeout(function () {
          if (done) return;
          readCart().then(function (after) {
            if (done || !after) return;
            var now = qtyByVariant(after);
            var delta = (now[vid] || 0) - (was[vid] || 0);
            if (delta > 0) {
              done = true;
              var line = (after.items || []).filter(function (l) { return l.variant_id === vid; })[0];
              if (line) {
                var one = {}, k;
                for (k in line) if (Object.prototype.hasOwnProperty.call(line, k)) one[k] = line[k];
                one.quantity = delta;   /* report what was added, not the line total */
                track({ items: [one] });
              }
            } else if (tries < 4) look();
          });
        }, tries === 1 ? 500 : 900);
      })();
    });
  }, true);
})();
